<div style="display: none;">
    <app-alerts-components
            [icon]="'ti-help-alt'"
            [id]="'help_section'"
            [title]="'first_steps' | localise"
            [btnLink]="'/faq'"
            [btnTitle]="'faq' | localise"
            [message]="'faq_message' | localise"></app-alerts-components>

    <div class="row" *ngIf="userProfile">
        <div class="col-md-12 grid-margin">
            <div class="row">
                <div class="col-6 col-xl-6 mb-4 mb-xl-0">
                    <h4 class="font-weight-bold">{{ 'hi' | localise }},</h4>
                    <h4 class="font-weight-normal mb-0">{{ userProfile.first_name + ' ' + userProfile.last_name }}</h4>
                </div>
                <div class="col-6 col-xl-6" style="text-align: right">
                    <div class="mb-3 mb-xl-0">
                        <button
                                (click)="router.navigate(['meals'])"
                                class="btn-cook btn btn-warning rounded-0 text-white">
                            <i class="mdi mdi-calendar-clock"></i>
                            {{ 'whats_going_to_cook_today' | localise }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="news-line" class="row">
        <div class="col-md-12 grid-margin">
            <div class="card bg-primary border-0 position-relative">
                <div class="card-body">
                    <!--                    <p class="card-title text-white">{{ 'whats_new' | localise }}</p>-->
                    <div class="row">
                        <div class="col-md-4 item">
                            <div class="d-flex flex-column flex-xl-row mt-4 mt-md-0">
                                <div class="content text-white" style="width: 100%;">
                                    <div class="d-flex flex-wrap align-items-center mb-2 mt-3 mt-xl-1">
                                        <h3 class="font-weight-light mr-2 mb-1 dashboard-news-title">
                                            <i class="ti-align-left icon-md"></i>
                                            {{ 'news' | localise }}
                                        </h3>
                                    </div>
                                    <div class="col-12 d-flex border-bottom border-info align-items-center justify-content-between px-0 pb-2 mb-3 dashboard-news-small-container">
                                        <div class="d-flex align-items-center">
                                            <i class="ti-angle-down mr-2 dashboard-news-small-icon"></i>
                                            <h5 class="mb-0 pointer dashboard-news-small-title"
                                                (click)="router.navigate(['news'])">
                                                {{ 'all_news' | localise }}
                                            </h5>
                                        </div>
                                    </div>

                                    <ng-container *ngIf="latestNews">
                                        <div
                                                (click)="router.navigate(['news/single', latestNews.news.id])"
                                                class="card-img-top animated fadeIn"
                                                *ngIf="latestNews.main_image"
                                                [lazyLoad]="constants.imagesUrl() + '/images/850x500/' + latestNews.main_image.type + '/' + latestNews.main_image.name + '/'">
                                            <div class="recipe-title">
                                                <span>{{ latestNews.news.title }}</span>
                                            </div>
                                        </div>

                                        <!--                                        <img-->
                                        <!--                                                (click)="router.navigate(['news/single', latestNews.news.id])"-->
                                        <!--                                                *ngIf="latestNews.main_image"-->
                                        <!--                                                class="news-img pointer"-->
                                        <!--                                                [src]="constants.imagesUrl() + '/images/100x150/' + latestNews.main_image.type + '/' + latestNews.main_image.name + '/'"/>-->

                                        <!--                                        <p-->
                                        <!--                                                (click)="router.navigate(['news/single', latestNews.news.id])"-->
                                        <!--                                                style="font-size: 1rem;"-->
                                        <!--                                                class="text-white pointer font-weight-light pr-lg-2 pr-xl-5">-->
                                        <!--                                            {{ latestNews.news.title }}-->
                                        <!--                                        </p>-->
                                    </ng-container>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 item">
                            <div class="d-flex flex-column flex-xl-row mt-4 mt-md-0">
                                <div class="content text-white" style="width: 100%;">
                                    <div class="d-flex flex-wrap align-items-center mb-2 mt-3 mt-xl-1">
                                        <h3 class="font-weight-light mr-2 mb-1 dashboard-news-title">
                                            <i class="ti-image icon-md"></i>
                                            {{ 'new_recipes' | localise }}
                                        </h3>
                                    </div>
                                    <div class="dashboard-news-small-container d-flex border-bottom border-info align-items-center justify-content-between px-0 pb-2 mb-3">
                                        <div class="d-flex align-items-center">
                                            <i class="ti-angle-down mr-2 dashboard-news-small-icon"></i>
                                            <h5 class="mb-0 pointer dashboard-news-small-title" (click)="router.navigate(['recipes'])">
                                                {{ 'all_recipes' | localise }}
                                            </h5>
                                        </div>
                                    </div>

                                    <ng-container *ngIf="latestRecipe">
                                        <div
                                                (click)="router.navigate(['recipes'])"
                                                class="card-img-top animated fadeIn"
                                                *ngIf="latestRecipe.images[0]"
                                                [lazyLoad]="constants.imagesUrl() + '/images/850x500/' + latestRecipe.images[0].type + '/' + latestRecipe.images[0].name + '/'">
                                            <div class="recipe-title">
                                                <span>{{ latestRecipe.recipe.title }}</span>
                                            </div>
                                        </div>

                                        <!--                                        <img-->
                                        <!--                                                (click)="router.navigate(['recipes'])"-->
                                        <!--                                                *ngIf="latestRecipe.images[0]"-->
                                        <!--                                                class="news-img pointer"-->
                                        <!--                                                [src]="constants.imagesUrl() + '/images/100x150/' + latestRecipe.images[0].type + '/' + latestRecipe.images[0].name + '/'"/>-->

                                        <!--                                        <p-->
                                        <!--                                                (click)="router.navigate(['recipes'])"-->
                                        <!--                                                style="font-size: 1rem;"-->
                                        <!--                                                class="text-white pointer font-weight-light pr-lg-2 pr-xl-5">-->
                                        <!--                                            {{ latestRecipe.recipe.title }}-->
                                        <!--                                        </p>-->
                                    </ng-container>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 item">
                            <div class="d-flex flex-column flex-xl-row mt-4 mt-md-0">
                                <div class="content text-white" style="width: 100%;">
                                    <div class="d-flex flex-wrap align-items-center mb-2 mt-3 mt-xl-1">
                                        <h3 class="font-weight-light mr-2 mb-1 dashboard-news-title">
                                            <i class="ti-video-clapper icon-md"></i>
                                            {{ 'new_video' | localise }}
                                        </h3>
                                    </div>
                                    <div class="dashboard-news-small-container d-flex border-bottom border-info align-items-center justify-content-between px-0 pb-2 mb-3">
                                        <div class="d-flex align-items-center">
                                            <i class="ti-angle-down mr-2 dashboard-news-small-icon"></i>
                                            <h5 class="mb-0 pointer dashboard-news-small-title" (click)="router.navigate(['videos'])">
                                                {{ 'all_video' | localise }}
                                            </h5>
                                        </div>
                                    </div>

                                    <ng-container *ngIf="latestVideoRecipe">
                                        <div
                                                (click)="router.navigate(['videos'])"
                                                class="card-img-top animated fadeIn"
                                                [lazyLoad]="'https://img.youtube.com/vi/' + getYoutubeCode(latestVideoRecipe.youtube_link) + '/maxresdefault.jpg'">
                                            <div class="recipe-title">
                                                <span>{{ latestVideoRecipe.title }}</span>
                                            </div>
                                        </div>

                                        <!--                                        <img-->
                                        <!--                                                (click)="router.navigate(['videos'])"-->
                                        <!--                                                class="news-img pointer"-->
                                        <!--                                                [src]="'https://img.youtube.com/vi/' + getYoutubeCode(latestVideoRecipe.youtube_link) + '/hqdefault.jpg'"/>-->

                                        <!--                                        <p-->
                                        <!--                                                (click)="router.navigate(['videos'])"-->
                                        <!--                                                style="font-size: 1rem;"-->
                                        <!--                                                class="text-white pointer font-weight-light pr-lg-2 pr-xl-5">-->
                                        <!--                                            {{ latestVideoRecipe.title }}-->
                                        <!--                                        </p>-->
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="shortcuts" class="row">
        <div class="col-md-4 stretch-card grid-margin grid-margin-md-0">
            <div class="card data-icon-card-primary pointer" (click)="onWebChat()">
                <div class="card-body">
                    <div class="row">
                        <div class="col-8 text-white">
                            <h3>{{ 'chat' | localise }}</h3>
                            <p class="text-white font-weight-light mb-0">
                                {{ 'chat_text' | localise }}
                            </p>
                        </div>
                        <div class="col-4 background-icon">
                            <i class="ti-comment"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-4 stretch-card grid-margin grid-margin-md-0">
            <div class="card data-icon-card-primary pointer" (click)="router.navigate(['faq'])">
                <div class="card-body">
                    <div class="row">
                        <div class="col-8 text-white">
                            <h3>{{ 'long_faq' | localise }}</h3>
                            <p class="text-white font-weight-light mb-0">
                                {{ 'long_faq_text' | localise }}
                            </p>
                        </div>
                        <div class="col-4 background-icon">
                            <i class="ti-search"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-4 stretch-card grid-margin grid-margin-md-0">
            <div class="card data-icon-card-primary pointer" (click)="router.navigate(['referrals'])">
                <div class="card-body">
                    <div class="row">
                        <div class="col-8 text-white">
                            <h3>{{ 'earn_with_us' | localise }}</h3>
                            <p class="text-white font-weight-light mb-0">
                                {{ 'earn_with_us_text' | localise }}
                            </p>
                        </div>
                        <div class="col-4 background-icon">
                            <i class="ti-star"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row" style="margin-top: 20px;">
        <div style="margin: 0 auto;" class="col-md-6 col-sm-12 col-xs-12 grid-margin stretch-card">
            <div class="card position-relative card-meals">
                <div class="card-body">
                    <button *ngIf="themeService.getCurrentTheme() !== 'dark'"
                            (click)="changeTheme('dark')"
                            class="btn btn-outline-secondary btn-icon-text dark-mode-button" type="button">
                        {{ 'try_dark_mode' | localise }} <i class="mdi mdi-theme-light-dark btn-icon-append"></i>
                    </button>

                    <button *ngIf="themeService.getCurrentTheme() === 'dark'"
                            (click)="changeTheme('light')"
                            class="btn btn-outline-secondary btn-icon-text light-mode-button" type="button">
                        {{ 'back_to_light_mode' | localise }} <i class="mdi mdi-theme-light-dark btn-icon-append"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
